import React, { useEffect, useImperativeHandle, useState } from "react";
import { Popup } from "devextreme-react";
import { Position, ToolbarItem } from "devextreme-react/popup";
import PdfViewer from "./pdfViewer";

export type PopupPdfViewerHandle = {
    show: (blobPdf: Blob) => void;
}

type State = {
    blobPdf: Blob;
    visible: boolean;
}

const PopupPdfViewer: React.ForwardRefRenderFunction<PopupPdfViewerHandle> = (props, ref) => {
    const [state, setState] = useState<State>({ blobPdf: null, visible: false });

    function hideInfo() {
        setState({ blobPdf: null, visible: false });
    }

    useImperativeHandle(ref, () => ({
        show(blobPdf) {
            setState({ blobPdf: blobPdf, visible: true });
        }
    }));

    return (
        <Popup
            visible={state.visible}
            dragEnabled={false}
            onHiding={hideInfo}
            hideOnOutsideClick={false}
            showTitle={false}
            showCloseButton fullScreen
            container=".dx-viewport"
        >
            <Position at="center" my="center" of="" collision="fit" />

            <ToolbarItem 
                widget="dxButton"
                toolbar="bottom"
                location="center"
                options={{
                    text: "Chiudi",
                    onClick: hideInfo
                }}
            />

            { state.blobPdf && <PdfViewer pdfBlob={state.blobPdf} /> }
        </Popup>
    )
}

export default React.forwardRef(PopupPdfViewer);